export let data = []

const set = features => {
  if (Array.isArray(features)) {
    data = features
  }
}

const get = () => data

const has = feature => data.indexOf(feature) > -1

export default {
  set,
  get,
  has
}
